module.exports = __webpack_public_path__ + "media/images/favicon-1f140dd28f0b515b0ef806983f00756b.png";